export function playAudioWhenReady(audio) {
  if (!audio) {
    return Promise.reject(new Error('audio is unavailable'));
  }

  const readyState = typeof HTMLMediaElement === 'undefined'
    ? 3
    : HTMLMediaElement.HAVE_FUTURE_DATA;
  if (audio.readyState >= readyState) {
    return Promise.resolve(audio.play());
  }

  return new Promise((resolve, reject) => {
    const cleanup = () => {
      audio.removeEventListener('canplay', onReady);
      audio.removeEventListener('error', onError);
      audio.removeEventListener('abort', onError);
    };
    const onReady = () => {
      cleanup();
      Promise.resolve(audio.play()).then(resolve).catch(reject);
    };
    const onError = () => {
      cleanup();
      reject(audio.error || new Error('audio failed to load'));
    };

    audio.addEventListener('canplay', onReady, { once: true });
    audio.addEventListener('error', onError, { once: true });
    audio.addEventListener('abort', onError, { once: true });
    audio.load();
  });
}
